import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PaymentScenarionActionMethodEnum } from '@zaoblako/shared/modules/task/enum/payment.scenarion.action.method.enum';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { PaymentTaskScenarioMethodNamePipe } from '@zaoblako/web/shared/pipes/payment-task-scenario-method-name.pipe';

@Component({
  selector: 'crm-payment-task-scenario-method-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, PaymentTaskScenarioMethodNamePipe],
  templateUrl: './payment-task-scenario-method-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentTaskScenarioMethodSingleSelectComponent {
  @Input() public method: PaymentScenarionActionMethodEnum;
  @Input() public styleClass: string;
  @Input() public class: string;
  @Input() public appendTo: any;

  @Output() public methodChange: EventEmitter<PaymentScenarionActionMethodEnum> =
    new EventEmitter<PaymentScenarionActionMethodEnum>();

  public options: PaymentScenarionActionMethodEnum[] = Object.values(PaymentScenarionActionMethodEnum);
}
